import React from 'react'
import { ActivityIndicator } from 'react-native'

import { colors } from '@zet/design-system'
import { Stack } from '@zet/design-system/layout'
import { SH2 } from '@zet/design-system/typography'
import { ModalStackParams } from 'modals/modalConfig'
import { ModalComponentProp } from 'react-native-modalfy'

type Props = ModalComponentProp<ModalStackParams, void, 'LoadingModal'>

export const LoadingModal = ({ modal: { getParam } }: Props) => {
  const title = getParam('title') || 'Loading...'
  return (
    <Stack className="items-center justify-center rounded-lg bg-white px-6 py-4">
      <ActivityIndicator color={colors.primary[100]} size={'large'} />
      <SH2 className="text-grays-80 mt-3">{title}</SH2>
    </Stack>
  )
}
